import { UserRole } from '../types/user'
import api from './axios'

const baseUrl = '/rest/v1/roles'

export async function getRoles(): Promise<PagedResult<UserRole>> {
    const res = await api.get<PagedResult<UserRole>>(baseUrl)
    return res.data
}